module.exports = __webpack_public_path__ + "img/patro_1.cf5cc990.png";